<template>
  <div id="app" class="container">
    <h1><img src="./assets/logo.svg" width="215" height="40"></h1>
    <h2>Helaas! Limoen bestaat niet meer.</h2>
	<p>We hebben besloten een andere weg in te slaan en te stoppen met Limoen. We zullen met elkaar blijven samenwerken en willen onze klanten blijven bedienen, ieder vanuit onze eigen expertise.</p>
	<p>Hieronder vindt u die expertises. Voor algemene vragen kunt u bij ons alledrie terecht.</p>

	<ul>
		<li v-for="p in processedCmd" :key="p.name">
			<strong>{{ p.name }}</strong><br />
			<p v-html="p.descr" />
		</li>
	</ul>

  </div>
</template>

<script>
import shuffle from 'lodash.shuffle';

export default {
  name: 'app',
  data () {
    return {
      cmd: [
		  {
			  name: 'Christiaan Smeenk',
			  descr: 'Voor vragen over <strong>design</strong> kunt u terecht bij Christiaan. Neem contact op via <a href="https://www.linkedin.com/in/christiaan-smeenk-ab98313/">LinkedIn</a>.',
			  
		  },
		  {
			  name: 'Maarten Koopmans',
			  descr: 'Voor vragen over <strong>back-end development</strong> kunt u terecht bij Maarten. Neem contact op via <a href="mailto:[email]">e-mail</a>.',
			  coded: 'saV7@LUUtGnap77QLUaR.aX',
		 	  key: '0VQeECbPDHUu4mgRovkt3SXZy6nh1A5iBOc9L8Y7fpGdIxTMwajNKJsWzqr2Fl'
		  },
		  {
			  name: 'David Krijgsman',
			  descr: 'Voor vragen over <strong>front-end development</strong> kunt u terecht bij David. Neem contact op via <a href="mailto:[email]">e-mail</a> of <a href="https://www.linkedin.com/in/david-krijgsman-3a80674/">LinkedIn</a>.',
			  coded: 'tUzz8@PROxPvmxpw2GR3.f8G',
			  key: 'yKTspkzLVfG9P35Z1ibgWuQtreC2ovaINDYAB4Xq0xjwlHMcmUdn8OREJ6S7Fh'
		  }
	  ]
    }
  },
  computed: {
	  processedCmd() {
		  return shuffle(this.cmd.map(p => {
			  return {
				  name: p.name,
				  descr: p.coded ? p.descr.replace('[email]', this.obfuscate(p.coded, p.key)) : p.descr
			  }
		  }));
	  }
  },
  methods: {
	  obfuscate(coded, key) {
		  let i, ltr, link='', shift=coded.length;
		for (i=0; i<coded.length; i++) {
			if (key.indexOf(coded.charAt(i))==-1) {
				ltr = coded.charAt(i)
				link += (ltr)
			}
			else {
				ltr = (key.indexOf(coded.charAt(i))-shift+key.length) % key.length
				link += (key.charAt(ltr))
			}
		}
		return link;
	  }
  }
}
</script>

<style lang="scss">
	* {
		font-family: 'open_sansregular';

	}
	.container {
		max-width: 880px;
		padding: 20px;
		margin: 0px auto;
	}
	h2 {
		font-family: 'montserratmedium';
		font-size: 2rem;
		color: #333333;
		margin-top: 50px;
		font-weight: normal;
	}
	p {
		line-height: 1.9;
		color: #404040;
	}

	ul {
		list-style: none;
		padding: 0;
		margin: 30px 0 0 0;
	}
	li {
		margin: 0 0 20px 0;
		padding: 0;

		strong {
			font-family: 'montserratmedium';
			font-weight: normal;
		}

		p {
			margin :0;
		}
	}
	a {
		color: #97c11f;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue